export default __webpack_public_path__ + "media/react/organisms/navbars/nav_bar/assets/Double-Checks-120x120-d1c64cae0d482edb64fc636a824b085b.png";